import { ArrowRight } from "lucide-react";

const HERO_BG =
  "https://customer-assets.emergentagent.com/job_indie-finance-1/artifacts/ysn90jot_Gemini_Generated_Image_j1rs16j1rs16j1rs.png%202026-0.png";

const goTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const Hero = () => {
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-[100svh] w-full overflow-hidden bg-navy text-ivory"
    >
      <img
        src={HERO_BG}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 w-full h-full object-cover opacity-25"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-navy/85 via-navy/70 to-navy/95" />

      <div className="container-editorial relative z-10 min-h-[100svh] flex flex-col">
        <div className="flex-1 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center pt-32 pb-20">
          <div className="lg:col-span-9 animate-fade-up">
            <p
              data-testid="hero-overline"
              className="text-[11px] tracking-[0.32em] uppercase text-goldSoft mb-8"
            >
              Consulente finanziario indipendente · Fee-only
            </p>

            <h1
              data-testid="hero-title"
              className="display-1 text-ivory mb-8"
            >
              Patrimoni costruiti<br />
              con <em className="italic text-goldSoft">disciplina</em>,<br />
              tutelati nel tempo.
            </h1>

            <p
              data-testid="hero-subtitle"
              className="lede max-w-2xl text-ivory/75"
            >
              Sono <span className="text-ivory font-medium">Manuel Faustini CFA</span> — affianco
              imprenditori, dirigenti e liberi professionisti nella pianificazione
              finanziaria: investimenti, previdenza e protezione patrimoniale. Di base
              indipendente, lavoro solo per il cliente, nessun altro.
            </p>

            <div className="mt-12 flex flex-wrap items-center gap-4">
              <button
                data-testid="hero-cta-primary"
                onClick={() => goTo("contatti")}
                className="btn-primary bg-ivory text-navy hover:bg-goldSoft hover:text-navy"
              >
                Prenota un colloquio <ArrowRight size={16} />
              </button>
              <button
                data-testid="hero-cta-secondary"
                onClick={() => goTo("servizi")}
                className="btn-ghost border-ivory/60 text-ivory hover:bg-ivory hover:text-navy"
              >
                Scopri i servizi
              </button>
            </div>
          </div>
        </div>

        <div className="border-t border-ivory/15 py-6 grid grid-cols-2 md:grid-cols-4 gap-6 text-ivory/75">
          {[
            ["Fee-only", "Compenso trasparente"],
            ["Indipendente", "Iscrizione OCF"],
            ["Fiduciario", "Interesse del cliente"],
            ["Executive Master", "Consulenza e Pianificazione finanziaria"],
          ].map(([k, v]) => (
            <div key={k} className="flex flex-col">
              <span className="font-serif text-xl text-ivory">{k}</span>
              <span className="text-xs tracking-[0.18em] uppercase text-ivory/55 mt-1">{v}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
